<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>
      <span>{{ 'FRONTEND.FORMS.HOURS_OF_OPERATION.HOURS_OF_OPERATION' | translate }}</span>
      <span *ngIf="markedAsRequired">*</span>
      <button
        mat-icon-button
        type="button"
        [color]="'primary'"
        (click)="openEditDialog()"
        [disabled]="control.disabled"
      >
        <mat-icon>mode_edit</mat-icon>
      </button>
    </mat-card-title>
  </mat-card-header>
  <ng-container *ngIf="(loading$ | async) === false; else loading">
    <mat-card-content *ngFor="let day of [0, 1, 2, 3, 4, 5, 6]" class="hours-of-operation__hours">
      <forms-regular-hours-display [control]="control" [dayOfWeek]="dayOfWeek(day)"></forms-regular-hours-display>
    </mat-card-content>
  </ng-container>
</mat-card>
<ng-template #loading>
  <glxy-loading-spinner></glxy-loading-spinner>
</ng-template>
